module.exports = __webpack_public_path__ + "static/media/flexible.5ee8d5e9.jpeg";